// Get user key from local storage
export const getUserKeyFromLocalStorage = (): string | null => {
  try {
    const localStorageItem = localStorage.getItem("user") || "{}";
    const userData = JSON.parse(localStorageItem);

    return userData.user.key || null;
  } catch (error) {
    console.error("Error extracting user key from localStorage:", error);
    return null;
  }
};

// Get user token from local storage
export const getTokenFromLocalStorage = () => {
  try {
    const localStorageItem = localStorage.getItem("user") || "{}";
    const userData = JSON.parse(localStorageItem);
    return userData.token || null;
  } catch (error) {
    console.error("Error extracting user token from localStorage:", error);
    return null;
  }
};

// Check if user is logged in
export const isUserLoggedIn = () => {
  try {
    const localStorageItem = localStorage.getItem("your_storage_key") || "{}";
    const userData = JSON.parse(localStorageItem);

    return !!(userData && userData.user);
  } catch (error) {
    console.error("Error checking if user is logged in:", error);
    return false;
  }
};
